import React, { useState } from "react";
import styles from "./SunTimesHeader.module.css";
import Section from "./Section/Section";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";

const SunTimesHeader = () => {
  const [open, setOpen] = useState(null);

  return (
    <div className={styles.SunTimesHeader}>
      <div>
        <span className={styles.Logo} aria-hidden="true" tabIndex="-1">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 667 55.4">
            <title>cst-inline-color-logo</title>
            <path
              d="M675,85c12.5,0,18.7-7.6,18.7-15.8,0-11.3-9.7-14.7-17-17.7-4.4-1.9-7.9-3.6-7.9-6.8,0-2.3,1.6-4,4.8-4,3.8,0,6.6,2.5,8.9,7L692.8,42c-3.5-7.1-9.4-12.3-19-12.3-10.5,0-18.2,6.2-18.2,15.6,0,11.2,9,14.6,16.2,17.5,4.8,1.9,8.7,3.5,8.7,7.1,0,2.8-1.9,4.6-5.6,4.6-4.7,0-8.2-3.8-10.5-7.7l-10.7,5.5C657.6,79.6,663.8,85,675,85m-57.4-1h33.1V73.1H631.1V61.8h13.4V51.2H631.1V41.9h18.8V30.7H617.7Zm-56.8,0h11.6V49.3h.1a119.23,119.23,0,0,0,2.3,13.3L579.6,84h9.8l4.9-21.5c.6-2.6,2.1-9.2,2.2-12.9h.2V84h12.7V30.7H592l-6.6,34.8h-.1L578,30.7H560.8Zm-21.9,0h13.4V30.7H538.9Zm-31,0h13.4V41.9h12.2V30.7H495.8V41.9H508Z"
              transform="translate(-26.7 -29.6)"
            ></path>
            <path
              d="M430.5,84h12.1V55.5h.1a61.6,61.6,0,0,0,3.4,6.8L458,84h12.4V30.7H458.3V59.3h-.1a98.51,98.51,0,0,0-4.2-9L444,30.7H430.6V84Zm-26.3.9c13.5,0,19-6.8,19-19.8V30.7H410.4V64.6c0,6.6-1.7,9.1-6,9.1s-6.1-2.5-6.1-9.2V30.7H384.9V65.2c0,12.8,5.8,19.7,19.3,19.7m-43,.1c12.5,0,18.8-7.6,18.8-15.8,0-11.3-9.7-14.7-17-17.7-4.4-1.9-7.9-3.6-7.9-6.8,0-2.3,1.6-4,4.8-4,3.8,0,6.6,2.5,8.9,7L379,42c-3.5-7.1-9.4-12.2-19-12.2-10.5,0-18.2,6.2-18.2,15.6,0,11.2,9,14.6,16.1,17.5,4.8,1.9,8.7,3.5,8.7,7.1,0,2.8-1.9,4.6-5.6,4.6-4.7,0-8.2-3.8-10.5-7.7L340,72.2c3.8,7.4,10,12.8,21.2,12.8M296.6,74c-5.8,0-8.6-6-8.6-16.7S290.8,41,296.6,41s8.6,5.6,8.6,16.3S302.4,74,296.6,74m0,11c11.7,0,22.1-8,22.1-27.7s-10.4-27.7-22.1-27.7-22.1,8-22.1,27.7S284.8,85,296.6,85m-49.4-.2c6.5,0,10.7-4.2,11.8-7.5h.1V84h9.7V56.8H250.2v9.9h6.5c-1,4.9-3.6,7.3-7.4,7.3-4.7,0-8.4-3-8.4-17s4.1-16,7.7-16,5.7,2.2,7.1,10.2l12.2-2.5c-2.3-14-8.3-19.1-18.8-19.1-14.1,0-21.6,9.9-21.6,27.5-.2,17.3,6.7,27.7,19.7,27.7M209,64.7h-8.6l1-4a133.55,133.55,0,0,0,3.3-13.6h.1c.8,4.9,1.9,8.4,3.2,13.6ZM197.8,75h13.7l2.2,9h13.5L211.6,30.5h-13L183,84h12.5ZM162.9,85c13,0,18-8.7,19.9-19.6l-12.6-2C169,71.2,167.3,74,163,74c-5.5,0-7.9-5.7-7.9-16.7S157.3,41,162.8,41c4.2,0,5.8,3.1,6.8,10l12.6-2.2c-1.4-11.8-6.5-19.1-19-19.1s-21.6,8-21.6,27.7S150.4,85,162.9,85m-41.1-1h13.4V30.7H121.8ZM73.4,84H86.8V61.8H99.9V84h13.4V30.7H99.9V50.8H86.8V30.7H73.4ZM47.9,85c13,0,18-8.7,19.9-19.6l-12.6-2C54,71.2,52.3,74,48,74c-5.5,0-7.9-5.7-7.9-16.7S42.4,41,47.9,41c4.2,0,5.8,3.1,6.8,10l12.6-2.2c-1.4-11.8-6.5-19.1-19-19.1s-21.6,8-21.6,27.7S35.4,85,47.9,85"
              transform="translate(-26.7 -29.6)"
            ></path>
            <polygon
              className={styles.Star}
              points="459.8 27 462.4 18.6 464.9 27 473.5 25 467.5 31.4 473.5 37.9 464.9 35.9 462.4 44.3 459.8 35.9 451.2 37.9 457.2 31.4 451.2 25 459.8 27"
            ></polygon>
          </svg>
        </span>
      </div>
      <nav className={styles.nav}>
        <div className={styles.HomicideTracker}>
          <p className={styles.HomicideTrackerLogo}>
            <strong>Homicide Project</strong>
          </p>
          <div className={styles.HomicideLinks}>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://graphics.suntimes.com/homicides/"
            >
              Victim List
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://graphics.suntimes.com/priority-communities/"
              className={styles.Active}
            >
              Priority Communities
            </a>
          </div>
        </div>
        <div className={styles.Social}>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/thechicagosuntimes"
          >
            <FacebookIcon />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/suntimes"
          >
            <TwitterIcon />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.youtube.com/channel/UCvU3ALK4osa_RV4znIToB2Q"
          >
            <YouTubeIcon />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.instagram.com/chicagosuntimes/"
          >
            <InstagramIcon />
          </a>
        </div>
      </nav>
    </div>
  );
};

export default SunTimesHeader;
